import "./toolbar.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";

import { PropTypeShapes } from "../../types";

const ToolbarGroup = forwardRef((props, ref) => {
  let style = {
    flexGrow: !isNil(props.flex) ? props.flex : props.position.includes("center") ? 1 : null,
    flexWrap: !isNil(props.flex) ? props.flexWrap : "nowrap"
  };

  if (!isNil(props.minWidth)) {
    style.minWidth = props.minWidth;
  }

  return (
    <div ref={ref} className={"toolbarGroup " + props.position} style={style}>
      {props.children}
    </div>
  );
});

ToolbarGroup.displayName = "ToolbarGroup";

ToolbarGroup.propTypes = {
  children: PropTypeShapes.elementOrArray,
  position: PropTypes.string.isRequired,
  flex: PropTypes.number,
  flexWrap: PropTypes.string,
  minWidth: PropTypes.number
};

export default ToolbarGroup;
